import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DuplicateCandidate, LeagueCompetitor, LeagueCompetitorResolveStatus} from "@model";
import {AbstractComponent} from "../../abstract.component";
import {TranslocoService} from "@ngneat/transloco";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-duplicate-candidates-modal',
  templateUrl: './duplicate-candidates-modal.component.html',
  styleUrl: './duplicate-candidates-modal.component.scss',
  standalone: false
})
export class DuplicateCandidatesModalComponent extends AbstractComponent{
  @Input() duplicates: DuplicateCandidate[] = [];
  @Input() raceNames: Map<number, string> = new Map<number, string>();

  @Output() onSave: EventEmitter<DuplicateCandidate> = new EventEmitter<DuplicateCandidate>();


  expandedRows = new Set<number>();
  saveDisabled: boolean = true;

  activeRow: number | null = null;
  decision: LeagueCompetitorResolveStatus | null = null;

  constructor(public translocoService: TranslocoService,
              public activeModal: NgbActiveModal
  ) {
    super();
  }

  ngOnInit() {
  }


  public reset(): void {
    this.expandedRows.clear();
    this.decision = null;
    this.activeRow = null;
  }

  toggleCandidate(i: number): void {
    if (this.expandedRows.has(i)) {
      this.expandedRows.delete(i);
    } else {
      this.expandedRows.add(i);
    }
  }

  toggleAll() {
    if (this.expandedRows.size) {
      this.expandedRows = new Set<number>();
    }
    else {
      this.duplicates.forEach((d:DuplicateCandidate, i: number) => {
        this.expandedRows.add(i)
      })
    }
  }

  swapCompetitors(i: number): void {
    const candidate: DuplicateCandidate = this.duplicates[i];
    if (candidate) {
      const newDuplicate = {...candidate.existing}
      candidate.existing = {...candidate.duplicate}
      candidate.duplicate = {...newDuplicate}
    }
    this.decision = null;
    this.activeRow = null;
  }


  onClose(): void {
    this.activeModal.dismiss();
  }

  onConfirm(): void {
    if (this.activeRow !== null && this.decision) {
      const candidate : DuplicateCandidate = {...this.duplicates[this.activeRow]}
      candidate.resolveStatus = this.decision;
      this.onSave.emit(candidate);
    }
  }


  select(i: number, type: LeagueCompetitorResolveStatus): void {
    if (this.activeRow === i && this.decision === type) {
      this.activeRow = null;
      this.decision = null;
      return;
    }
    this.expandedRows.clear();
    this.expandedRows.add(i);
    this.activeRow = i;
    this.decision = type;
  }

  isMatchedMember(dup: DuplicateCandidate, member: LeagueCompetitor, isExistingSide: boolean): boolean {
    if (!dup.matchedMembers?.length) return false;
    return dup.matchedMembers.some(pair => {
      const m = isExistingSide ? pair.memberFromExisting : pair.memberFromDuplicate;
      return m?.id === member.id;
    });
  }

  getUnmatchedMembers(dup: DuplicateCandidate, isExistingSide: boolean): LeagueCompetitor[] {
    const members = isExistingSide ? dup.existing?.teamMembers : dup.duplicate?.teamMembers;
    if (!members?.length) return [];
    return members.filter(m => !this.isMatchedMember(dup, m, isExistingSide));
  }

  protected readonly LeagueCompetitorResolveStatus = LeagueCompetitorResolveStatus;

}

